/**
 * MOVENMUSE FRONTEND - MAIN APP COMPONENT
 * 
 * This is the root component of the MovenMuse React frontend application.
 * It sets up the global providers, styling, and main layout structure.
 * 
 * FEATURES:
 * - Global event context for event management
 * - Toast notifications for user feedback
 * - Bootstrap styling framework
 * - Navigation bar and routing
 * 
 * PROVIDERS:
 * - EventProvider: Manages global event state and operations
 * - UserProvider: Already wrapped in index.js for user authentication
 * 
 * COMPONENTS:
 * - NavBar: Main navigation component
 * - Router: Handles all page routing and navigation
 * - ToastContainer: Displays notification messages
 */
// Bootstrap CSS is imported once in index.js - removed duplicate import
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import React from "react";
import { useLocation } from "react-router-dom";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";
import Router from "./Router";
import { ToastContainer } from "react-toastify";
import { EventProvider } from "./EventContext";

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      {/* Global Event Context Provider - manages event state across the app */}
      <EventProvider>
        {/* Toast Notification Container - displays success/error messages */}
        <ToastContainer
          position="bottom-left"      // Position notifications in bottom-left corner
          autoClose={3000}           // Auto-close notifications after 3 seconds
          hideProgressBar={false}    // Show progress bar for auto-close
          newestOnTop={false}        // New notifications appear below existing ones
          closeOnClick               // Allow users to click to close notifications
          rtl={false}                // Left-to-right text direction
          pauseOnFocusLoss           // Pause auto-close when window loses focus
          draggable                  // Allow users to drag notifications
          pauseOnHover               // Pause auto-close when hovering over notification
        />

        {/* Main Application Container */}
        <div className="App">
          {/* Navigation Bar - hidden on admin pages */}
          {!isAdminRoute && <NavBar />}

          {/* Router Component - handles all page routing and navigation */}
          <Router />

          {/* Footer - hidden on admin pages */}
          {!isAdminRoute && <Footer />}
        </div>
      </EventProvider>
    </>
  );
}

export default App;
